(function () {
  // Reads a public Google Sheet via its built-in JSON endpoint (gviz).
  // Matches columns by header keyword, so column order in the sheet
  // doesn't matter and header wording can vary slightly.
  function fetchSheetPartners(sheetId, gid) {
    if (!sheetId) return Promise.resolve([]);

    var url =
      'https://docs.google.com/spreadsheets/d/' + sheetId +
      '/gviz/tq?tqx=out:json&gid=' + (gid || '0');

    return fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var start = text.indexOf('{');
        var end = text.lastIndexOf('}');
        var json = JSON.parse(text.substring(start, end + 1));
        var cols = json.table.cols.map(function (c) {
          return (c.label || '').toLowerCase();
        });

        function colIndex(keywords) {
          for (var i = 0; i < cols.length; i++) {
            for (var k = 0; k < keywords.length; k++) {
              if (cols[i].indexOf(keywords[k]) !== -1) return i;
            }
          }
          return -1;
        }

        var nameIdx = colIndex(['name']);
        var cityIdx = colIndex(['city']);
        var commentIdx = colIndex(['comment', 'special']);
        var latIdx = colIndex(['lat']);
        var lngIdx = colIndex(['lng', 'long']);

        function cellValue(row, idx) {
          if (idx === -1 || !row.c || !row.c[idx]) return '';
          return row.c[idx].v;
        }

        return (json.table.rows || [])
          .map(function (row) {
            var name = cellValue(row, nameIdx);
            var city = cellValue(row, cityIdx);
            var comment = cellValue(row, commentIdx);
            var lat = parseFloat(cellValue(row, latIdx));
            var lng = parseFloat(cellValue(row, lngIdx));
            return {
              name: name ? String(name).trim() : '',
              city: city ? String(city).trim() : '',
              comment: comment ? String(comment).trim() : '',
              lat: lat,
              lng: lng,
              isAustin: city ? String(city).toLowerCase().indexOf('austin') !== -1 : false,
            };
          })
          .filter(function (p) {
            return p.name && !isNaN(p.lat) && !isNaN(p.lng);
          });
      })
      .catch(function (err) {
        console.error('Partner locator: could not load Google Sheet data', err);
        return [];
      });
  }

  function renderList(listEl, partners) {
    listEl.innerHTML = '';
    if (!partners.length) {
      var empty = document.createElement('li');
      empty.style.padding = '1rem';
      empty.style.color = '#6b7280';
      empty.style.fontSize = '13px';
      empty.textContent = 'No partners to show yet.';
      listEl.appendChild(empty);
      return;
    }
    partners.forEach(function (partner, index) {
      var li = document.createElement('li');
      li.className = 'partner-locator__item' + (partner.isAustin ? '' : ' is-far');
      li.setAttribute('data-index', index);
      li.setAttribute('tabindex', '0');

      var dot = document.createElement('span');
      dot.className = 'partner-locator__pin-dot';
      dot.setAttribute('aria-hidden', 'true');

      var textWrap = document.createElement('div');
      textWrap.className = 'partner-locator__item-text';

      var namePara = document.createElement('p');
      namePara.className = 'partner-locator__name';
      namePara.textContent = partner.name + ' ';
      var citySpan = document.createElement('span');
      citySpan.className = 'partner-locator__city';
      citySpan.textContent = '— ' + partner.city;
      namePara.appendChild(citySpan);
      textWrap.appendChild(namePara);

      if (partner.comment) {
        var commentPara = document.createElement('p');
        commentPara.className = 'partner-locator__comment';
        commentPara.textContent = partner.comment;
        textWrap.appendChild(commentPara);
      }

      li.appendChild(dot);
      li.appendChild(textWrap);
      listEl.appendChild(li);
    });
  }

  function initMapAndList(sectionId, data, partners) {
    var mapEl = document.getElementById('partner-map-' + sectionId);
    var listEl = document.getElementById('partner-list-' + sectionId);
    if (!mapEl || !window.google || !window.google.maps) return;

    renderList(listEl, partners);

    var map = new google.maps.Map(mapEl, {
      center: { lat: data.centerLat, lng: data.centerLng },
      zoom: data.zoom,
      disableDefaultUI: true,
      zoomControl: true,
    });

    var infoWindow = new google.maps.InfoWindow();
    var markers = [];
    var listItems = listEl.querySelectorAll('.partner-locator__item');

    partners.forEach(function (partner, index) {
      var marker = new google.maps.Marker({
        position: { lat: partner.lat, lng: partner.lng },
        map: map,
        title: partner.name,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 8,
          fillColor: partner.isAustin ? data.primaryColor : data.accentColor,
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2,
        },
      });

      markers[index] = marker;
      var listItem = listItems[index];

      function activate() {
        listItems.forEach(function (li) { li.classList.remove('is-active'); });
        if (listItem) listItem.classList.add('is-active');

        infoWindow.setContent(
          '<div style="font-family: Inter, sans-serif; padding: 2px;">' +
            '<p style="font-weight:700; margin:0; color:#002FA7;">' + partner.name + '</p>' +
            '<p style="font-size:12px; color:#6b7280; margin:2px 0 6px;">' + partner.city + '</p>' +
            (partner.comment ? '<p style="font-size:13px; color:#6b7280; font-style:italic; margin:0;">' + partner.comment + '</p>' : '') +
          '</div>'
        );
        infoWindow.open(map, marker);
        map.panTo(marker.getPosition());
      }

      marker.addListener('click', activate);

      if (listItem) {
        listItem.addEventListener('click', activate);
        listItem.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activate();
          }
        });
      }
    });
  }

  function initPartnerLocator(sectionId, data) {
    fetchSheetPartners(data.sheetId, data.sheetGid).then(function (partners) {
      initMapAndList(sectionId, data, partners);
    });
  }

  window.initAllPartnerLocators = function () {
    var allData = window.partnerLocatorData || {};
    Object.keys(allData).forEach(function (sectionId) {
      initPartnerLocator(sectionId, allData[sectionId]);
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    if (window.google && window.google.maps) {
      window.initAllPartnerLocators();
      return;
    }
    var allData = window.partnerLocatorData || {};
    var firstKey = Object.keys(allData)[0];
    if (!firstKey || !allData[firstKey].apiKey) return;

    var script = document.createElement('script');
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=' +
      allData[firstKey].apiKey +
      '&callback=initAllPartnerLocators';
    script.async = true;
    document.head.appendChild(script);
  });
})();